module.exports = __webpack_public_path__ + "img/silver2.e77ffb1a.png";